<div class="overlay">
	<div class="overlay__inner">
		<div class="overlay__content">
			<img alt="Loading" src="/assets/img/loader.gif" class="loader-gif" />
		</div>
	</div>
</div>
